/*============================================================================
 Ajax the add to cart experience by revealing it in a side drawer
 Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
 (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

 This file includes:
 - Basic Shopify Ajax API calls
 - Ajax cart plugin

 This requires:
 - jQuery 1.8+
 - handlebars.min.js (for cart template)
 - modernizr.min.js
 - snippet/ajax-cart-template.liquid

 Customized version of Shopify's jQuery API
 (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
 ==============================================================================*/
 if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

 /*============================================================================
  API Helper Functions
  ==============================================================================*/
 function attributeToString(attribute) {
   if ((typeof attribute) !== 'string') {
     attribute += '';
     if (attribute === 'undefined') {
       attribute = '';
     }
   }
   return jQuery.trim(attribute);
 };
 
 /*============================================================================
  API Functions
  ==============================================================================*/
 ShopifyAPI.onCartUpdate = function(cart) {
   // alert('There are now ' + cart.item_count + ' items in the cart.');
 };

 ShopifyAPI.cartContent ={
  loaded: false,
  item_count: 0,
  total_price: 0,
  total_weight: 0,
  collectionATC:false,
  showGWP: false
 }
 
 ShopifyAPI.updateCartNote = function(note, callback) {
   var $body = $(document.body),
     params = {
       type: 'POST',
       url: '/cart/update.js',
       data: 'note=' + attributeToString(note),
       dataType: 'json',
       beforeSend: function() {
         $body.trigger('beforeUpdateCartNote.ajaxCart', note);
       },
       success: function(cart) {
         if ((typeof callback) === 'function') {
           callback(cart);
         }
         else {
           ShopifyAPI.onCartUpdate(cart);
         }
         $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
       },
       error: function(XMLHttpRequest, textStatus) {
         $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
         ShopifyAPI.onError(XMLHttpRequest, textStatus);
       },
       complete: function(jqxhr, text) {
         $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
       }
     };
   jQuery.ajax(params);
 };
 
 ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
   var data = eval('(' + XMLHttpRequest.responseText + ')');
   if (!!data.message) {
     var $elm = $('.ajaxcart__header').after('<div class="errors qty-error" style="background-color: #feedee;padding: 5px 10px;color: #444444;">'+ data.description +'</div>');
     var $error = $('.ajaxcart__header').find('.qty-error');
     setTimeout(function() {
       if ($error.length > 0) {
         $error.remove();
       }
     }, 2000);
     console.warn(data.message + '(' + data.status  + '): ' + data.description);
   }
 };
 
 /*============================================================================
  POST to cart/add.js returns the JSON of the cart
  - Allow use of form element instead of just id
  - Allow custom error callback
  ==============================================================================*/
 ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
   var formData = form instanceof FormData
     ? { id: form.id, quantity: form.quantity }
     : jQuery(form).serialize();
 
   var $body = $(document.body),
     params = {
       type: 'POST',
       url: '/cart/add.js',
       data: formData,
       dataType: 'json',
       beforeSend: function(jqxhr, settings) {
         $body.trigger('beforeAddItem.ajaxCart', form);
       },
       success: function(line_item) {
         if ((typeof callback) === 'function') {
           callback(line_item, form);
         }
         else {
           ShopifyAPI.onItemAdded(line_item, form);
         }
         $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
       },
       error: function(XMLHttpRequest, textStatus) {
         if ((typeof errorCallback) === 'function') {
           errorCallback(XMLHttpRequest, textStatus);
         }
         else {
           ShopifyAPI.onError(XMLHttpRequest, textStatus);
         }
         $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
       },
       complete: function(jqxhr, text) {
         $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
       }
     };
   jQuery.ajax(params);
 };
 
 // Get from cart.js returns the cart in JSON
 ShopifyAPI.getCart = function(callback) {

  fetch('/cart.js')
  .then(function (response){    
      return response.json();
  })
  .then(function (json){
    callback(json)
    ShopifyAPI.onCartUpdate(json);
    $(document.body).trigger('afterGetCart.ajaxCart', json);
  });


 };
 
 // POST to cart/change.js returns the cart in JSON
 ShopifyAPI.changeItem = function(line, quantity, callback) {
   var $body = $(document.body),
     params = {
       type: 'POST',
       url: '/cart/change.js',
       data: 'quantity=' + quantity + '&line=' + line,
       dataType: 'json',
       beforeSend: function() {
         $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
       },
       success: function(cart) {
         if ((typeof callback) === 'function') {
           callback(cart);
         }
         else {
           ShopifyAPI.onCartUpdate(cart);
         }
         $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
       },
       error: function(XMLHttpRequest, textStatus) {
         $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
         ShopifyAPI.onError(XMLHttpRequest, textStatus);
       },
       complete: function(jqxhr, text) {
         $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
       }
     };
   jQuery.ajax(params);
 };
 
 ShopifyAPI.removeItem = function(id, callback) {
   var $body = $(document.body),
     params = {
       type: 'POST',
       url: '/cart/change.js',
       data: 'quantity=0&id=' + id,
       dataType: 'json',
       beforeSend: function() {
         $body.trigger('beforeRemoveItem.ajaxCart', [id]);
       },
       success: function(cart) {
         if ((typeof callback) === 'function') {
           callback(cart);
         }
         else {
           ShopifyAPI.onCartUpdate(cart);
         }
         $body.trigger('afterRemoveItem.ajaxCart', [id, cart]);
       },
       error: function(XMLHttpRequest, textStatus) {
         Shopify.onError(id, textStatus);
       },
       complete: function(jqxhr, text) {
         $body.trigger('completeRemoveItem.ajaxCart', [this, jqxhr, text]);
       }
     };
   jQuery.ajax(params)
 };
 
 /*============================================================================
  Ajax Shopify Add To Cart
  ==============================================================================*/
 var ajaxCart = (function(module, $) {
 
   'use strict';
 
   // Public functions
   var init, loadCart;
 
   // Private general variables
   var settings, isUpdating, $body;
 
   // Private plugin variables
   var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer, $cartItemCountSelector;
 
   // Private functions
   var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback,shippingProgress, gwpProgress, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;
 
   /*============================================================================
    Initialise the plugin and define global options
    ==============================================================================*/
   init = function (options) {
 
     // Default settings
     settings = {
       formSelector       : 'form[action^="/cart/add"]',
       cartContainer      : '#CartContainer',
       addToCartSelector  : 'input[type="submit"]',
       cartCountSelector  : null,
       cartCostSelector   : null,
       moneyFormat        : '$',
       disableAjaxCart    : false,
       enableQtySelectors : true,
       cartItemCountSelector: '[data-cart-item-count]',
       domainType: 'AU',
       freeShippingPrice: 70,
     };
 
     // Override defaults with arguments
     $.extend(settings, options);
 
     // Select DOM elements
     $formContainer     = $(settings.formSelector);
     $cartContainer     = $(settings.cartContainer);
     $addToCart         = $formContainer.find(settings.addToCartSelector);
     $cartCountSelector = $(settings.cartCountSelector);
     $cartCostSelector  = $(settings.cartCostSelector);
     $cartItemCountSelector = $(settings.cartItemCountSelector);
 
     // General Selectors
     $body = $(document.body);
 
     // Track cart activity status
     isUpdating = false;
 
     // Setup ajax quantity selectors on the any template if enableQtySelectors is true
     if (settings.enableQtySelectors) {
       qtySelectors();
     }
 
     // Take over the add to cart form submit action if ajax enabled
     if (!settings.disableAjaxCart) {
       formOverride();
     }
 
     // Run this function in case we're using the quantity selector outside of the cart
     adjustCart();
   };
 
   loadCart = function () {
    //  $body.addClass('drawer--is-loading');
     ShopifyAPI.getCart(cartUpdateCallback);
   };
 
   updateCountPrice = function (cart) {
     $($cartItemCountSelector).html(cart.item_count);
     if ($cartCountSelector) {
       $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
 
       if (cart.item_count === 0) {
         $cartCountSelector.addClass('hidden-count');
       }
     }
     if ($cartCostSelector) {
       $cartCostSelector.html(slate.Currency.formatMoney(cart.total_price, settings.moneyFormat));
     }
   };
 
   formOverride = function () {
     $body.on('submit', settings.formSelector, function(evt) {
       evt.preventDefault();
       evt.stopPropagation();
     });
 
     $body.on('click', settings.addToCartSelector, function(evt) {
       var $el = $(this),
           $formContainer = $el.closest(settings.formSelector);
 
       // Submit closest form
       evt.stopPropagation();
       $formContainer.submit();
 
       // Add class to be styled if desired
       $el.removeClass('is-added').addClass('is-adding');
 
       // Remove any previous quantity errors
       $formContainer.siblings('.qty-error').remove();
       
       ShopifyAPI.cartContent.loaded = true;
 
       ShopifyAPI.addItemFromForm($formContainer, itemAddedCallback, itemErrorCallback);
     });
   };
 
   itemAddedCallback = function (product) {
     $addToCart.removeClass('is-adding').addClass('is-added');
 
     ShopifyAPI.getCart(cartUpdateCallback);
   };
 
   itemErrorCallback = function (XMLHttpRequest, textStatus) {
     var data = eval('(' + XMLHttpRequest.responseText + ')');
     $addToCart.removeClass('is-adding is-added');
 
     if (!!data.message) {
       if (data.status == 422) {
         $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
       }
     }
   };
 
   cartUpdateCallback = function (cart) {
     // Update quantity and price
     updateCountPrice(cart);
     if(ShopifyAPI.cartContent.loaded == false){
      buildCart(cart);
     }else if(ShopifyAPI.cartContent.item_count != cart.item_count && ShopifyAPI.cartContent.total_price != cart.total_price && ShopifyAPI.cartContent.total_weight != cart.total_weight){
      buildCart(cart);
     }else if(cart.item_count <=1){
      buildCart(cart);
     }
   };

   shippingProgress = function (cart) {
    
    let cartTotal = cart.total_price;
      
    let progressBar = document.querySelector('.free-shipping__progress-bar');
    let progressBarTitle = document.querySelector('.free-shipping__progress-title');
    let progressBarContainer = document.querySelector('.free-shipping__container');
    let threshold = progressBar.dataset.threshold * 100;
    let currentProgress = cartTotal / threshold;

    progressBar.style.setProperty('--shipping-progress', `${currentProgress * 100}%`);

    if (currentProgress >= 1) {
          progressBarTitle.innerHTML = progressBarContainer.dataset.thresholdCompleteTitle + '<b> FREE SHIPPING</b>  ✈️';
        } else {         
          
          progressBarTitle.innerText = progressBarContainer.dataset.thresholdTitle.replace('', slate.Currency.formatMoney(threshold - cartTotal)) ; 
          progressBarTitle.innerHTML = progressBarTitle.innerText + ' <b>FREE SHIPPING</b> ✈️'
       }      
   }

   gwpProgress = function (cart) {
    
    let cartTotal = cart.total_price;
    
    let progressBar = document.querySelector('.gwp__progress-bar');
    let progressBarTitle = document.querySelector('.gwp__progress-title');
    let progressBarContainer = document.querySelector('.gwp__container');
    let threshold = progressBar.dataset.threshold * 100;
    let currentProgress = cartTotal / threshold;    

    progressBar.style.setProperty('--gwp-progress', `${currentProgress * 100}%`);

    if (currentProgress >= 1) {
          progressBarTitle.innerHTML = '<b>FREE GIFT ALERT! </b> ' + progressBarContainer.dataset.thresholdCompleteTitle;
        } else {         
          
          progressBarTitle.innerText = progressBarContainer.dataset.thresholdTitle.replace('', slate.Currency.formatMoney(threshold - cartTotal));
          progressBarTitle.innerHTML = progressBarTitle.innerText + ' <b><a href="/collections/gift-with-purchase">A FREE GIFT 💌</a></b>'
       }      
   }

 
   buildCart = function (cart) {
     // Start with a fresh cart div
     $cartContainer.empty();     

     if(cart.item_count > 0){
      document.querySelectorAll('.cart-status__container').forEach(function (el) {
        el.style.display = 'initial'
      })
     }else{
      document.querySelectorAll('.cart-status__container').forEach(function (el) {
        el.style.display = 'none'
      })
     }

     shippingProgress(cart);
     gwpProgress(cart);
 
     // Show empty cart
     if (cart.item_count === 0) {
       $cartContainer
         .append('<div class="ajax-cart__empty align-center"><svg class="ajax-cart__empty_bag" width="18px" height="18px" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.08 18"><g id="Layer_1-2" data-name="Layer 1"><path d="m8.03,18c-1.59,0-3.18,0-4.77,0-1.88,0-3.25-1.37-3.25-3.24,0-3,0-6,0-9,0-.58.2-.78.78-.78.91,0,1.81,0,2.72,0,.38,0,.38,0,.37-.39-.02-.68.05-1.34.31-1.98C4.88.88,6.7-.2,8.52.03c1.9.24,3.37,1.67,3.65,3.54.06.38.04.75.04,1.13,0,.21.07.28.28.28.95,0,1.9,0,2.86,0,.52,0,.74.21.74.73,0,3.05.01,6.11,0,9.16,0,1.74-1.41,3.12-3.15,3.13-1.63,0-3.27,0-4.9,0Zm-.01-1.16c1.6,0,3.2,0,4.8,0,1.24,0,2.1-.8,2.1-2.04.02-2.8,0-5.6,0-8.41,0-.18-.05-.26-.24-.26-.75,0-1.49,0-2.24,0-.17,0-.24.06-.24.24,0,.35,0,.7,0,1.05,0,.38-.25.65-.58.64-.33,0-.57-.27-.58-.65,0-.34,0-.68,0-1.02,0-.18-.05-.26-.24-.26-1.84,0-3.68,0-5.52,0-.19,0-.25.08-.24.26,0,.34,0,.68,0,1.02,0,.38-.25.65-.58.65-.33,0-.58-.27-.58-.64,0-.34-.01-.68,0-1.02,0-.2-.07-.27-.27-.27-.73,0-1.45,0-2.18,0-.19,0-.27.05-.27.26,0,2.8,0,5.6,0,8.41,0,1.23.87,2.04,2.1,2.04,1.58,0,3.16,0,4.74,0Zm.03-11.86c.92,0,1.83,0,2.75,0,.18,0,.27-.04.26-.24-.02-.37.02-.74-.05-1.1-.25-1.18-.95-1.99-2.1-2.33-1.19-.35-2.24-.04-3.09.87-.66.71-.81,1.59-.77,2.53,0,.22.08.27.29.27.91,0,1.81,0,2.72,0Z"/></g></svg><h3 class="ajax-cart__empty-title h4">' + 'Uh-oh!'+  '<br/>' + 'Your bag is empty!' + '</h3><p>' +  'TIME TO GO SHOPPING' + '</p><ul class="ajax-cart__linklist"><li><a href="/collections/new">New Arrivals<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon--small icon-chevron-right" viewBox="0 0 640 640"><path d="M160 640c-4.095 0-8.19-1.562-11.313-4.687-6.25-6.248-6.25-16.38 0-22.627L425.373 336 148.687 59.313c-6.25-6.248-6.25-16.38 0-22.627s16.38-6.25 22.627 0l288 288c6.25 6.248 6.25 16.38 0 22.627l-288 288A15.949 15.949 0 0 1 160 640z"></path></svg></a></li><li><a href="/collections/best-selling">Best Selling<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon--small icon-chevron-right" viewBox="0 0 640 640"><path d="M160 640c-4.095 0-8.19-1.562-11.313-4.687-6.25-6.248-6.25-16.38 0-22.627L425.373 336 148.687 59.313c-6.25-6.248-6.25-16.38 0-22.627s16.38-6.25 22.627 0l288 288c6.25 6.248 6.25 16.38 0 22.627l-288 288A15.949 15.949 0 0 1 160 640z"></path></svg></a></li><li><a href="/collections/sale">Sale<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon--small icon-chevron-right" viewBox="0 0 640 640"><path d="M160 640c-4.095 0-8.19-1.562-11.313-4.687-6.25-6.248-6.25-16.38 0-22.627L425.373 336 148.687 59.313c-6.25-6.248-6.25-16.38 0-22.627s16.38-6.25 22.627 0l288 288c6.25 6.248 6.25 16.38 0 22.627l-288 288A15.949 15.949 0 0 1 160 640z"></path></svg></a></li></ul></div>');
       cartCallback(cart);
       return;
     }
 
     // Handlebars.js cart layout
     var items = [],
       item = {},
       data = {},
       source = document.getElementById("CartTemplate").innerHTML,
       template = Handlebars.compile(source);
 
     // Add each item to our handlebars.js data     
      cart.items.forEach((cartItem, index) => {        
 
       /* Hack to get product image thumbnail
        *   - If image is not null
        *     - Remove file extension, add _small, and re-add extension
        *     - Create server relative link
        *   - A hard-coded url of no-image
        */
       if (cartItem.image != null){
         var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_150x$1").replace('http:', '');
       } else {
         var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
       }
 
       var varID = cartItem.variant_id;
       var comparePrice;

       fetch('/products/' + cartItem.handle + '.js')
       .then(response => response.json())
       .then(product => {
         product.variants.forEach(variant => {
           if(variant.compare_at_price == null || variant.compare_at_price == 0){
               document.getElementById(`final-price-${cartItem.variant_id}`).style.color = "black"
             }
           if (variant.id == varID && variant.compare_at_price !== 0 && variant.compare_at_price != null) {
             comparePrice = slate.Currency.formatMoney(variant.compare_at_price, settings.moneyFormat);            
             if(variant.compare_at_price != cartItem.final_price && comparePrice != "$0" ){
               document.getElementById(`cart-compare-at-${cartItem.variant_id}`).innerHTML = comparePrice
               document.getElementById(`final-price-${cartItem.variant_id}`).classList.add("compare-sale")
             }
           }
         });
       });
 
       // loop over properties and remove bad ones

      // Get the properties object from cartItem
        const { properties } = cartItem;

        // Filter out the unwanted properties
        cartItem.properties = Object.fromEntries(          
          Object.entries(properties).filter(([key]) => {
            return !(
              key.includes('_io_') ||
              key.includes('_internal_') ||
              key.includes('_swell')
            );
          })
        );

 
       if (window.location.host === 'www.beginningboutique.com'){
         var auVariantText = ["4", "6", "8", "10", "12", "14", "16", "18"]

         if (cartItem.variant_title.includes("US")){
           cartItem.variant_title = cartItem.variant_title 
         }else if(new RegExp(auVariantText.join("|")).test(cartItem.variant_title)) {
           cartItem.variant_title = "AU " + cartItem.variant_title 
         };
         
       }
       
 
       // Create item's data object and add to 'items' array
       item = {
         key: cartItem.key,
         line: index + 1, // Shopify uses a 1+ index in the API
         url: cartItem.url,
         cartVariantId: cartItem.variant_id,
         img: prodImg,
         name: cartItem.product_title,
         variation: cartItem.variant_title,
         properties: cartItem.properties,
         itemAdd: cartItem.quantity + 1,
         itemMinus: cartItem.quantity - 1,
         itemQty: cartItem.quantity,
         price: slate.Currency.formatMoney(cartItem.price, settings.moneyFormat),
         vendor: cartItem.vendor,
         linePrice: slate.Currency.formatMoney(cartItem.line_price, settings.moneyFormat),
         originalLinePrice: slate.Currency.formatMoney(cartItem.original_line_price, settings.moneyFormat),
         discounts: cartItem.discounts,
         discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
         compareValid: comparePrice !== "<span class='money'>$0</span>" && comparePrice !== "$0" ? true : false,
         comparePrice: comparePrice,
       };
 
       items.push(item);
     });
 
     // Free Shipping Calculation
     var freeShipUnder =  (cart.total_price / 100) < settings.freeShippingPrice;
     var freeShipLeftUntil = slate.Currency.formatMoney((settings.freeShippingPrice*100) - cart.total_price, settings.moneyFormat);
 
     // Gather all cart data and add to DOM
     data = {
       items: items,
       note: cart.note,
       freeShipUnder: freeShipUnder,
       freeShipLeftUntil: freeShipLeftUntil,
       totalPrice: slate.Currency.formatMoney(cart.total_price, settings.moneyFormat),
       totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', slate.Currency.formatMoney(cart.total_discount, settings.moneyFormat)),
       totalCartDiscountApplied: cart.total_discount === 0 ? false : true
     }
 
     $cartContainer.append(template(data));     
 
     cartCallback(cart);     
     ShopifyAPI.cartContent.loaded = true;
     ShopifyAPI.cartContent.item_count = cart.item_count;
     ShopifyAPI.cartContent.total_price = cart.total_price;
     ShopifyAPI.cartContent.total_weight = cart.total_weight;      
   };
 
   cartCallback = function(cart) {
     $body.removeClass('drawer--is-loading');
     let progressBar = document.querySelector('.gwp__progress-bar');
     let threshold = progressBar.dataset.threshold * 100;


     if(ShopifyAPI.cartContent.loaded){
      $body.trigger('afterCartLoad.ajaxCart', cart);
     }else if(ShopifyAPI.cartContent.collectionATC){
      $body.trigger('afterCartLoad.ajaxCart', cart);
      ShopifyAPI.cartContent.loaded = false;
     }

     if (window.theme.gwpEnabled ) { 
        ajaxCartGwp.load();
        ShopifyAPI.cartContent.showGWP = true        
      }     
     
 
     if (window.Shopify && Shopify.StorefrontExpressButtons) {
       Shopify.StorefrontExpressButtons.initialize();
     }

    let gwpElements = document.querySelectorAll('.ajaxcart__gwp-root');
    let showGWP = cart.total_price > threshold;

    gwpElements.forEach(function (el) {
      el.style.display = showGWP ? 'block' : 'none';
    });

 
   };
 
   adjustCart = function () {
     // Delegate all events because elements reload with the cart
 
     // Add or remove from the quantity
     $body.on('click', '.ajaxcart__qty-adjust', function() {
       if (isUpdating) {
         return;
       }
 
       var $el = $(this),
         line = $el.data('line'),
         $qtySelector = $el.siblings('.ajaxcart__qty-num'),
         qty = parseInt($qtySelector.val().replace(/\D/g, ''));
 
       var qty = validateQty(qty);
 
       // Add or subtract from the current quantity
       if ($el.hasClass('ajaxcart__qty--plus')) {
         qty += 1;
       } else {
         qty -= 1;
         if (qty <= 0) qty = 0;
       }
 
       // If it has a data-line, update the cart.
       // Otherwise, just update the input's number
       if (line) {
         updateQuantity(line, qty);
       } else {
         $qtySelector.val(qty);
       }
     });
 
     // Update quantity based on input on change
     $body.on('change', '.ajaxcart__qty-num', function() {
       if (isUpdating) {
         return;
       }
 
       var $el = $(this),
         line = $el.data('line'),
         qty = parseInt($el.val().replace(/\D/g, ''));
 
       var qty = validateQty(qty);
 
       // If it has a data-line, update the cart
       if (line) {
         updateQuantity(line, qty);
       }
     });
 
     // Prevent cart from being submitted while quantities are changing
     $body.on('submit', 'form.ajaxcart', function(evt) {
       if (isUpdating) {
         evt.preventDefault();
       }
     });
 
     // Highlight the text when focused
     $body.on('focus', '.ajaxcart__qty-adjust', function() {
       var $el = $(this);
       setTimeout(function() {
         $el.select();
       }, 50);
     });
     
     $body.on('click', '.ajaxcart__remove-item', function() {      
       var $el = $(this),
           line = $el.data('line'),
           id = $el.data('id');
       
     removeItem(id, line);     
     });
 
     function updateQuantity(line, qty) {
       isUpdating = true;
 
       // Add activity classes when changing cart quantities
       var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');
 
       if (qty === 0) {
         $row.parent().addClass('is-removed');
       }
 
       // Slight delay to make sure removed animation is done
       setTimeout(function() {
         try {
           ShopifyAPI.changeItem(line, qty, adjustCartCallback);
         } catch (e) {
           console.warn('Could not adjust cart item quantity', e);
         }
       }, 250);
     }
     
     function removeItem(id, line) {
       isUpdating = true;

       // Add activity classes when changing cart quantities
       var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');
 
       $row.parent().addClass('is-removed');
 
       // Slight delay to make sure removed animation is done
       setTimeout(function() {
         try {
           ShopifyAPI.removeItem(id, adjustCartCallback);
         } catch (e) {
           console.warn('Could not remove item', e);
         }
       }, 250);
     }
 
     // Save note anytime it's changed
     $body.on('change', 'textarea[name="note"]', function() {
       var newNote = $(this).val();
 
       // Update the cart note in case they don't click update/checkout
       ShopifyAPI.updateCartNote(newNote, function(cart) {});
     });
   };
 
   adjustCartCallback = function (cart) {
     // Update quantity and price
     
     updateCountPrice(cart);
 
     // Reprint cart on short timeout so you don't see the content being removed
     setTimeout(function() {
       isUpdating = false;
       
       ShopifyAPI.getCart(buildCart);
     }, 150)
   };
 
   createQtySelectors = function() {
     // If there is a normal quantity number field in the ajax cart, replace it with our version
     if ($('input[type="number"]', $cartContainer).length) {
       $('input[type="number"]', $cartContainer).each(function() {
         var $el = $(this),
           currentQty = $el.val();
 
         var itemAdd = currentQty + 1,
           itemMinus = currentQty - 1,
           itemQty = currentQty;
 
         var source   = $("#AjaxQty").html(),
           template = Handlebars.compile(source),
           data = {
             key: $el.data('id'),
             itemQty: itemQty,
             itemAdd: itemAdd,
             itemMinus: itemMinus
           };
 
         // Append new quantity selector then remove original
         $el.after(template(data)).remove();
       });
     }
   };
 
   qtySelectors = function() {
     // Change number inputs to JS ones, similar to ajax cart but without API integration.
     // Make sure to add the existing name and id to the new input element
     var numInputs = $('input[type="number"]');
 
     if (numInputs.length) {
       numInputs.each(function() {
         var $el = $(this),
           currentQty = $el.val(),
           inputName = $el.attr('name'),
           inputId = $el.attr('id');
 
         var itemAdd = currentQty + 1,
           itemMinus = currentQty - 1,
           itemQty = currentQty;
 
         var source   = $("#JsQty").html(),
           template = Handlebars.compile(source),
           data = {
             key: $el.data('id'),
             itemQty: itemQty,
             itemAdd: itemAdd,
             itemMinus: itemMinus,
             inputName: inputName,
             inputId: inputId
           };
 
         // Append new quantity selector then remove original
         $el.after(template(data)).remove();
       });
 
       // Setup listeners to add/subtract from the input
       $('.js-qty__adjust').on('click', function() {
         var $el = $(this),
           id = $el.data('id'),
           $qtySelector = $el.siblings('.js-qty__num'),
           qty = parseInt($qtySelector.val().replace(/\D/g, ''));
 
         var qty = validateQty(qty);
 
         // Add or subtract from the current quantity
         if ($el.hasClass('js-qty__adjust--plus')) {
           qty += 1;
         } else {
           qty -= 1;
           if (qty <= 1) qty = 1;
         }
 
         // Update the input's number
         $qtySelector.val(qty);
       });
     }
   };
 
   validateQty = function (qty) {
     if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
       // We have a valid number!
     } else {
       // Not a number. Default to 1.
       qty = 1;
     }
     return qty;
   };
 
   module = {
     init: init,
     load: loadCart
   };
 
   return module;
 
 }(ajaxCart || {}, jQuery));
 
 
 
 
 
 
